import React, { useRef, useState, useEffect } from 'react';
import Map, { Source, Layer } from 'react-map-gl';
import { Slider } from '@mui/material';
import { MAPBOX_TOKEN } from '../config/constants';
import '../css/SlopeMap.css'; 

const HI_LAYER_ID = 'hi-zoom-layer';

export default function SlopeMap() {
  const [minSlope, setMinSlope] = useState(0);
  const [minElev, setMinElev] = useState(0);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current) return;
    const map = mapRef.current.getMap();

    
    const applyFilter = () => {
      if (map.getLayer(HI_LAYER_ID)) {
        map.setFilter(HI_LAYER_ID, [
          'all',
          ['has', 'elevation'],
          ['has', 'max_slope'],
          ['>=', ['get', 'elevation'], minElev],
          ['>=', ['get', 'max_slope'], minSlope]
        ]);
      }
    };

    map.on('idle', applyFilter);
    applyFilter();

    return () => map.off('idle', applyFilter);
  }, [minSlope, minElev]);

  return (
    <div className="slope-map-container">
      <div className="sidebar">
        <p><strong>Minimum Slope: {minSlope}</strong></p>
        <Slider
          value={minSlope}
          min={0}
          max={5}
          step={0.1}
          onChange={(_, v) => setMinSlope(v)}
        />
        <p style={{ marginTop: '20px' }}><strong>Minimum Elevation: {minElev}</strong></p>
        <Slider
          value={minElev}
          min={0}
          max={1000}
          step={10}
          onChange={(_, v) => setMinElev(v)}
        />
      </div>

      <div className="map-container">
        <Map
          ref={mapRef}
          initialViewState={{ longitude: -118.2426, latitude: 34.0549, zoom: 8 }}
          mapStyle="mapbox://styles/mapbox/streets-v11"
          mapboxAccessToken={MAPBOX_TOKEN}
          className="mapbox-map"
          style={{ width: '100%', height: '100%' }} // ⬅️ make it taller
          onLoad={() => mapRef.current?.resize()}
          
        >
          <Source
            id="constant"
            type="vector"
            url="mapbox://arjunnair15.2677274s"
          >
            <Layer
              id="constant"
              source-layer="output_proper"
              type="fill"
              minzoom={0}
              maxzoom={16}
              paint={{
                'fill-color': '#ff0000',
                'fill-opacity': 0.6
              }}
            />
          </Source>

          <Source
            id="hi-zoom-source"
            type="vector"
            url="mapbox://arjunnair15.a3d607m3"
          >
            <Layer
              id={HI_LAYER_ID}
              source-layer="reconstructed_lacounty_clipped_4"
              type="fill"
              minzoom={5}
              maxzoom={13}
              paint={{
                'fill-color': '#088',
                'fill-opacity': 0.6
              }}
            />
          </Source>
        </Map>
      </div>
    </div>
  );
}
